exports = module.exports = require("../../../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".congratulation-modal .congratulation-modal__image{padding:16px 16px 0}.congratulation-modal .congratulation-modal__image img{width:100%;-o-object-fit:cover;object-fit:cover}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_lodash@4.18.1_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-640919b5","scoped":false,"hasInlineConfig":false}!./node_modules/.pnpm/sass-loader@7.3.1_webpack@3.12.0/node_modules/sass-loader/dist/cjs.js!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_lodash@4.18.1_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserOnboarding/components/CongratulationModal.vue
// module id = wEKp
// module chunks = 45